import React from 'react';
import classnames from 'classnames';
import DeviationFlags from '../../ActionBar/buttons/DeviationFlags';
import DateAndMatureIndicator from '../_partials/DateAndMatureIndicator';
import Title from '../_partials/Title';
import s from './MobileSubmissionDetails.scss';
var MobileSubmissionDetails = function (_a) {
    var className = _a.className, deviation = _a.deviation, _b = _a.deviation, title = _b.title, dailyDeviation = _b.dailyDeviation, showTitle = _a.showTitle;
    return (React.createElement("div", { className: classnames(s['root'], className, dailyDeviation && s['with-flag']) },
        dailyDeviation && (React.createElement("div", { className: s['flag'] },
            React.createElement(DeviationFlags, { deviation: deviation }))),
        React.createElement(Title, { title: title, showTitle: showTitle, className: s['title'] }),
        React.createElement(DateAndMatureIndicator, { publishedTime: deviation.publishedTime, isMature: deviation.isMature, className: s['date'] })));
};
MobileSubmissionDetails.displayName = 'MobileSubmissionDetails';
export default MobileSubmissionDetails;
//# sourceMappingURL=MobileSubmissionDetails.js.map